
import * as actionTypes from '../../Constants/customFieldActionTypes';
import { async } from 'q';
import qs from 'query-string';
import * as customFieldServices from "../../services/customFields/index";
import API from '../../Constants/customField/API'

export function customFields(allCustomFields) {
    return {
        type: actionTypes.FETCH_ALL_CUSTOM_FILEDS,
        payload: { allCustomFields: allCustomFields }
    }    
}

export function fetchAllCustomFeilds(firmID) {
    return async dispatch => {
      var customFieldResponse = await customFieldServices.cfRequest.getAllCustomFields(API.getCustomField,firmID,"test")
        
        customFieldResponse.customFields.map((cfield) => {
            cfield.isSingleSelectOptionsEdited = false;
        });
      return dispatch(customFields(customFieldResponse.customFields))
    }
}